export default __webpack_public_path__ + "static/media/slipperModel.c58f6ec2.png";